import axios from "axios"
import { fromJS } from "immutable"
import config from "../config"

export const setContact = contact => {
    return {
        type: "AGENT_CONTACT",
        data: contact,
    }
}

export const setContactAny = contact => {
    return {
        type: "AGENT_CONTACT_ANY",
        data: contact,
    }
}

export const setUserPermissions = data => {
    return {
        type: "AGENT_PERMISSIONS",
        data,
    }
}

export const setPresence = (presence, changed) => {
    return {
        type: "AGENT_PRESENCE",
        data: presence,
        changed: changed,
    }
}

export const getContact = contact => {
    return {
        type: "AGENT_CONTACT_GET",
        data: contact,
    }
}

export const createOrUpdateContact = contact => {
    return {
        type: "AGENT_CONTACT_CREATE_OR_UPDATE",
        data: contact,
    }
}

export const setCampaign = campaign => {
    return {
        type: "AGENT_CAMPAIGN",
        data: campaign,
    }
}

export const setCampaignInt = campaign => {
    return {
        type: "AGENT_CAMPAIGN_INT",
        data: campaign,
    }
}

export const setPayment = payment => {
    return {
        type: "AGENT_PAYMENT",
        data: payment,
    }
}

export const getList = filter => dispatch => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${config.apiEndpoint}users/search`, { filter: filter || {} })
            .then(response => {
                resolve(fromJS(response.data ? response.data : response))
            })
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const setIntercepted = enabled => {
    return {
        type: "AGENT_INTERCEPTED",
        data: enabled,
    }
}

export const setIntercepting = enabled => {
    return {
        type: "AGENT_INTERCEPTING",
        data: enabled,
    }
}
